<template>
    <div class="lead-score-modal">
        <GoalModal
            data-qa="lead-score-modal-goal"
            :is-open="isOpen"
            :title="$t('funnel.edit.sideBar.goal.scoreAchieved')"
            :summary-text="$t('funnel.edit.sideBar.goal.scoreAchieved.summary')"
            @update-config="updateConfig"
            @close-modal="closeModal"
        >
            <template #goalParameters>
                <span>{{ $t('funnel.edit.sideBar.goal.scoreAchieved.label.score') }}</span>
                <div class="multiselect-container">
                    <DsMultiselect
                        v-model="selectedScoreValue"
                        bind-value-only
                        data-qa="selected-lead-score-modify-value"
                        label-prop="name"
                        value-prop="id"
                        help-text
                        help-text-prop="additional"
                        class="modify-status"
                        :options="modifyOptions"
                    />
                    <span>{{ $t('funnel.edit.sideBar.goal.scoreAchieved.label.to') }}</span>
                    <DsMultiselect
                        v-model="selectedFlameValue"
                        bind-value-only
                        data-qa="selected-lead-score-flame-value"
                        label-prop="image"
                        value-prop="id"
                        help-text
                        required
                        help-text-prop="additional"
                        class="rating-status"
                        :options="ratingOptions"
                        :force-invalid="emptyFlameValue"
                    >
                        <template #option="{ option }">
                            <div :data-qa="option.name" class="rating-option">
                                {{ option.image }}
                            </div>
                        </template>
                        <template v-if="emptyFlameValue" #help>
                            {{ $t('global.field.required') }}
                        </template>
                    </DsMultiselect>
                    <span>{{ $t('funnel.edit.sideBar.goal.scoreAchieved.label.or.more.flames') }}</span>
                </div>
            </template>
        </GoalModal>
    </div>
</template>

<script>
import GoalModal from '../goalModal/GoalModal.vue';

export default {
    components: { GoalModal },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        appInfo: {
            type: Object,
            required: true,
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                    scoreIncreased: 'TRUE',
                    flameValue: 3,
                },
            }),
        },
    },

    emits: ['close-modal', 'update-cell-value'],

    data() {
        return {
            ratingOptions: [
                { id: 1, name: '1', image: '🔥' },
                { id: 2, name: '2', image: '🔥🔥' },
                { id: 3, name: '3', image: '🔥🔥🔥' },
                { id: 4, name: '4', image: '🔥🔥🔥🔥' },
                { id: 5, name: '5', image: '🔥🔥🔥🔥🔥' },
            ],
            modifyOptions: [
                { id: 'TRUE', name: this.$t('funnel.edit.sideBar.goal.scoreAchieved.modify.increase') },
                { id: 'FALSE', name: this.$t('funnel.edit.sideBar.goal.scoreAchieved.modify.decrease') },
            ],
            selectedScoreValue: this.cell?.value?.scoreIncreased ?? 'TRUE',
            selectedFlameValue: Number.parseInt(this.cell?.value?.flameValue, 10) ?? 3,
            emptyFlameValue: false,
        };
    },

    methods: {

        allowSave() {
            return !!this.selectedScoreValue && !!this.selectedFlameValue;
        },
        updateConfig() {
            if (this.allowSave()) {
                const cell = { ...this.cell };

                cell.value = cell.value || {};

                cell.value.scoreIncreased = this.selectedScoreValue;
                cell.value.flameValue = this.selectedFlameValue;

                this.$emit('update-cell-value', { cell });
            } else {
                this.emptyFlameValue = true;
            }
        },
        closeModal() {
            this.$emit('close-modal');
        },
    },
};
</script>

<style lang="scss" scoped>
.multiselect-container {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
}

.multiselect-container .multiselect {
    margin-bottom: 0;
    width: 30%
}

.multiselect-container .multiselect > div.dropdown {
    width: 100%
}

.multiselect-container > span {
    margin: 10px;
}

.rating-option {
    align-items: center;
    padding-left: 10px;
}
</style>
